module.exports = __webpack_public_path__ + "img/Benin.bac9d8b2.png";